export default "__VITE_ASSET__58e98726__"